module.exports = __webpack_public_path__ + "static/media/Student certificate (3).58ca5cbc.png";